import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaire-templates/field-templates/{fieldTemplateId}/pdf-fills']['DELETE'];
type Input = ThisApi['params'];

const deletePdfFillsForFieldTemplate = async ({ fieldTemplateId }: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.delete(`/questionnaire-templates/field-templates/${fieldTemplateId}/pdf-fills`);
  return data.data;
};

export default deletePdfFillsForFieldTemplate;
